import { buildMedicationFormSchema } from '../../../../common';
import {
  MEDICATION_DOSAGE_MIN_LENGTH,
  MEDICATION_NAME_MIN_LENGTH,
  MEDICATION_PHYSICIAN_NAME_MIN_LENGTH,
  MEDICATION_REASON_MIN_LENGTH,
} from './constants';

export const MEDICATION_FORM_SCHEMA = buildMedicationFormSchema({
  medicationNameMinLength: MEDICATION_NAME_MIN_LENGTH,
  dosageMinLength: MEDICATION_DOSAGE_MIN_LENGTH,
  physicianNameMinLength: MEDICATION_PHYSICIAN_NAME_MIN_LENGTH,
  reasonMinLength: MEDICATION_REASON_MIN_LENGTH,
});
